import { useState, useEffect } from 'react'
import { fetchSheetData } from '../api'
import LoadingView from './LoadingView'

interface SheetTablePageProps {
  targetId: string
  refreshKey?: number
}

export default function SheetTablePage({ targetId, refreshKey }: SheetTablePageProps) {
  const [header,  setHeader]  = useState<string[]>([])
  const [rows,    setRows]    = useState<string[][]>([])
  const [loading, setLoading] = useState(false)
  const [error,   setError]   = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    setError(null)
    fetchSheetData(targetId)
      .then((data) => { setHeader(data.header); setRows(data.rows) })
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false))
  }, [targetId, refreshKey])

  if (loading) return <LoadingView />

  if (error) {
    return (
      <div style={{ flex: 1, padding: '24px' }}>
        <div style={{ padding: '10px 14px', background: '#450a0a', color: '#fca5a5', fontSize: '13px', borderRadius: '8px', border: '1px solid #7f1d1d' }}>
          ⚠ {error}
        </div>
      </div>
    )
  }

  return (
    <div style={{ flex: 1, overflow: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', minWidth: '100%', fontSize: '12px' }}>
        <thead>
          <tr>
            {header.map((col, i) => (
              <th
                key={i}
                style={{
                  position: 'sticky',
                  top: 0,
                  padding: '8px 14px',
                  background: 'var(--surface)',
                  borderBottom: '1px solid var(--border)',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  color: 'var(--text-muted)',
                  fontWeight: 600,
                  fontSize: '11px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i}>
              {header.map((_, j) => (
                <td
                  key={j}
                  style={{
                    padding: '6px 14px',
                    color: 'var(--text)',
                    borderBottom: '1px solid rgba(96,96,96,0.18)',
                    whiteSpace: 'nowrap',
                    maxWidth: 260,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {row[j] ?? ''}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {rows.length === 0 && (
        <div style={{ textAlign: 'center', padding: '48px', color: 'var(--text-muted)', fontSize: '14px', opacity: 0.6 }}>
          No data yet.
        </div>
      )}
    </div>
  )
}
